import LandingPage from './LandingPage.js';

export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/LandingPage/index.js